export default function MetricCard({ icon, title, value, color = "primary" }) {
  // Bootstrap colors: primary, secondary, success, danger, warning, info, dark
  return (
    <div className="bg-white border border-light rounded shadow-sm overflow-hidden">
      <div className="p-3 d-flex align-items-center gap-3">
        <div>{icon}</div>
        <div>
          <h6 className="text-muted mb-1">{title}</h6>
          <p className="fw-bold fs-5 mb-0">{value}</p>
        </div>
      </div>
      <div
        className={`w-100`}
        style={{ height: "6px", backgroundColor: getColor(color) }}
      ></div>
    </div>
  );
}

// Helper: return a Bootstrap-compatible color (or fallback)
function getColor(color) {
  const colorMap = {
    blue: "#0d6efd", // Bootstrap "primary"
    red: "#dc3545", // "danger"
    green: "#198754", // "success"
    yellow: "#ffc107", // "warning"
    gray: "#6c757d", // "secondary"
    primary: "#0d6efd",
    danger: "#dc3545",
    success: "#198754",
    warning: "#ffc107",
    info: "#0dcaf0",
    dark: "#212529",
    secondary: "#6c757d",
  };

  return colorMap[color] || "#0d6efd"; // fallback to blue
}
